<template>
  <div class="cloud_wrapper mt-2">
    <div class="mb-100">
      	<h4>{{this.heading}}</h4>
    </div>
    <div class="loader_con" v-if="!isClicked">
      	<p>Please Select a Date Range</p>
    </div>
    <div v-else>
      <div class="loader_con" v-if="isApicalled">
        <v-progress-circular
            indeterminate
            color="#1F8F58"
            size="40"
        ></v-progress-circular>  
      </div>
      <div class="loader_con" v-else-if="wordclouddata.length === 0">
          <p>No data present</p>
      </div>
      <div v-else>
        <vue-word-cloud
          	style="height: 220px; padding: auto; margin: 12px auto 0px"
          	:words="wordclouddata"
          	:rotation="(word) => word.weight <= num1 ? -90 : word.weight <= num2 ? 0: word.weight >= num2? 0: 90"
          	:color="(word) => `#` + Math.floor(Math.random() * 360+Math.floor(Math.random() * 100)+Math.floor(Math.random() * 50)).toString(16)"
          	rotationUnit="deg"
          	:animation-duration="10"
          	:font-size-ratio=4
          	:spacing="0.4"
          	font-weight="normal"
          	:weight="(word) => word.weight"
        />        
      </div>
    </div>
  </div>
</template>

<script>
import VueWordCloud from "vuewordcloud";
import API_URL from "../../../../helpers/apiUrls"

export default {
  	components: {
  	  	[VueWordCloud.name]: VueWordCloud,
  	},
  	data() {
  	  	return {
  	  	    word: '',
  	  	    wordclouddata : [],
  	  	    isApicalled : false,
				isClicked : false,
				max : 0,
				min : 100000,
				num1 : 0,
				num2 : 0,
  	  	};
  	},
  	props : {
  	    type : {
  	      type: String,
  	    },
  	    data : {
  	      type : Object,
  	    },
  	    heading : {
  	      type: String,
  	    },
  	    click : {
  	      type: Boolean
  	    }
  	},

  	watch:{
		max:function(){
			this.num1 = this.getRndInteger();
			this.num2 = this.getRndInteger();
		},
  	  	click:function(){

		    this.isApicalled = true;
  	        this.getWordCloudData();
		    this.isClicked = true;
		    this.wordclouddata = [];
  	  }
  	},

  	methods:{
	getRndInteger() {
  		return Math.floor(Math.random() * (this.max - this.min)) + this.min;
	},
    getWordCloudData(){
        const successHandler = (response) => {
            if (response.status === 200) {
              this.isLoading = false;
              this.isApicalled = false;
              console.log("WORD CLOUD DATA ", response.data.buckets);
              response.data.buckets.map(item => {
                  var obj = {
                    text : "",
                    weight : 0,
                  }
				  this.max = Math.max(this.max, item.count)
				  this.min = Math.min(this.min, item.count)
                  obj.text = item.eng_title,
                  obj.weight = item.count,
                  this.wordclouddata.push(obj)
              })
            }
        }

        const errorHandler = (error) => {
            this.showToast(
                "Something went wrong internally!",
                "error",
                10000
            );
            console.log(error);
            this.toggleLoader(false);
            this.nodata = false;
            this.isApicalled = false;
        };
		console.log("STATES", this.data.states);
        console.log("TERM", this.data.selectTerm);
        var data = {}
        if(this.data.selectTerm !== ""){
            data = {
                start_month : this.data.startMonth,
                end_month : this.data.endMonth,
                states : this.data.states,
                query : this.data.selectTerm,            
            }
        } else {
            data = {
                start_month : this.data.startMonth,
                end_month : this.data.endMonth,
                states : this.data.states,
            }
        }

        console.log("DATA",data);
        if(this.type === "crop"){
          this.newRequestPOST(
              API_URL.getWordCloudCrop,
              data,
              {},
              successHandler,
              errorHandler, 
              process.env.VUE_APP_API_BASE_URL_DISCOVERY
          )
        } else if(this.type === "topic"){
          this.newRequestPOST(
             API_URL.getWordCloudTopic,
             data,
             {},
             successHandler,
             errorHandler, 
             process.env.VUE_APP_API_BASE_URL_DISCOVERY
          )     
        }

    },
  }
};
</script>

<style lang="scss" scoped>
.cloud_wrapper{
  background-color: #fbfbfb;
  height: 300px;
  border-radius: 8px;
  padding: 0.8rem;
}
.loader_con{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;

  p{
    color: #999999;
    font-size: 0.9rem;
    font-family: "Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif;
  }
}
</style>